import React from 'react';
import AdminCategories from './Page';
import { CategoryProvider } from 'providers';

export default function Page() {
  return (
    <CategoryProvider>
      <AdminCategories />
    </CategoryProvider>
  );
}
